import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

const customerCareLinks = [
  { label: "Contact us", href: "/contact" },
  { label: "Shipping", href: "/shipping" },
  { label: "Returns", href: "/returns" },
  { label: "Privacy", href: "/privacy" },
  { label: "Cookies", href: "/cookies" },
  { label: "FAQs", href: "/faqs" },
  { label: "Terms", href: "/terms" },
];

const paymentMethods = ["Visa", "Mastercard", "American Express", "Discover"];

function Footer() {
  const submitTimerRef = useRef(null);

  useEffect(
    () => () => {
      if (submitTimerRef.current) window.clearTimeout(submitTimerRef.current);
    },
    []
  );

  const handleInternalLink = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const shopLinks = siteConfig.nav.filter(
    (item) => item.href === "/shop" || item.href.includes("category=")
  );

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__container site-footer__main">
        <section className="site-footer__column site-footer__brand-column">
          <Link
            className="site-footer__brand"
            to="/"
            aria-label={siteConfig.logo.ariaLabel}
            onClick={handleInternalLink}
          >
            <span>{siteConfig.logo.text}</span>
            <small>{siteConfig.logo.tagline}</small>
          </Link>
          <p className="site-footer__description">{siteConfig.description}</p>
          {siteConfig.social.length > 0 && (
            <div className="site-footer__social" aria-label="Social media">
              {siteConfig.social.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {item.label}
                  <span aria-hidden="true">↗</span>
                </a>
              ))}
            </div>
          )}
        </section>

        <nav className="site-footer__column" aria-label="Shop navigation">
          <h2>Shop</h2>
          <ul>
            {shopLinks.map((item) => (
              <li key={item.href}>
                <Link to={item.href} onClick={handleInternalLink}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="site-footer__column" aria-label="Customer care">
          <h2>Here to help</h2>
          <ul>
            {customerCareLinks.map((item) => (
              <li key={item.href}>
                <Link to={item.href} onClick={handleInternalLink}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <section className="site-footer__column site-footer__visit">
          <h2>Visit &amp; connect</h2>
          <address>
            <span>{siteConfig.contact.address}</span>
            <a href={`mailto:${siteConfig.contact.email}`}>
              {siteConfig.contact.email}
            </a>
            <span>{siteConfig.contact.hours}</span>
          </address>
          <Link
            className="site-footer__contact-link"
            to="/contact"
            onClick={handleInternalLink}
          >
            Send us a note <span aria-hidden="true">→</span>
          </Link>
        </section>
      </div>

      <div className="site-footer__container site-footer__bottom">
        <p>
          © {new Date().getFullYear()} {siteConfig.brandName}. All good things
          reserved.
        </p>
        <div className="site-footer__policy-links">
          <Link to="/privacy" onClick={handleInternalLink}>
            Privacy
          </Link>
          <Link to="/terms" onClick={handleInternalLink}>
            Terms
          </Link>
          <Link to="/cookies" onClick={handleInternalLink}>
            Cookies
          </Link>
          <Link to="/faqs" onClick={handleInternalLink}>
            FAQs
          </Link>
          <Link to="/shipping" onClick={handleInternalLink}>
            Shipping
          </Link>
        </div>
        <div className="site-footer__payments" aria-label="Accepted payments">
          {paymentMethods.map((method) => (
            <span key={method}>{method}</span>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
